export const PT_CART = "/cart";
export const PT_ADDRESS = "/changeAdd";
export const PT_DATEPICK = "/date-picker";
export const PT_PAYMODE = "/paymode";
export const PT_ORDERSTATUS = "/complete/:status/:iserorr";
export const CART_STACK_PATHS_CONTAIN_CHECK = (pathname) => {
  let firstPart = pathname.split("/").filter(Boolean)[0];
  let paths = PT_CART + PT_ADDRESS + PT_DATEPICK + PT_PAYMODE + PT_ORDERSTATUS;
  return paths.toUpperCase().includes(firstPart.toUpperCase());
};
